import * as React from 'react';
type Props = {
  className?: string;
};
export function ThumbsDown({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-thumbs-down"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 14.6C15.4477 14.6 15 14.1523 15 13.6V4.00001C15 3.44772 15.4477 3.00001 16 3.00001C16.5523 3.00001 17 3.44772 17 4.00001V13.6C17 14.1523 16.5523 14.6 16 14.6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8942 20.4477C12.7227 20.7902 12.3706 21.0047 11.9876 20.9999C11.4597 20.9934 10.9401 20.8676 10.4676 20.6321C9.99506 20.3965 9.5819 20.0572 9.25896 19.6395C8.93601 19.2218 8.71162 18.7366 8.60256 18.22C8.49364 17.7041 8.50256 17.1702 8.62865 16.6583L8.62914 16.6563L9.12823 14.6H5.73599C5.33235 14.6 4.93426 14.506 4.57323 14.3255C4.21221 14.145 3.89817 13.8829 3.65599 13.56C3.4138 13.2371 3.25013 12.8622 3.17793 12.4651C3.10574 12.0681 3.12695 11.6597 3.23988 11.2724L5.10388 4.87237C5.2614 4.33231 5.58994 3.85754 6.03999 3.52C6.49004 3.18246 7.03742 3 7.59999 3H18.4C19.0895 3 19.7509 3.27393 20.2385 3.76152C20.7261 4.24912 21 4.91044 21 5.6V12C21 12.6896 20.7261 13.3509 20.2385 13.8385C19.7509 14.3261 19.0895 14.6 18.4 14.6H16.1925C16.0809 14.6001 15.9715 14.6312 15.8766 14.6901C15.7818 14.7489 15.7052 14.833 15.6555 14.933L15.6542 14.9357L12.8942 20.4477ZM11.4423 18.8802L13.8645 14.043L13.8652 14.0415C14.0805 13.609 14.412 13.245 14.8226 12.9904C15.2337 12.7354 15.7077 12.6003 16.1915 12.6H18.4C18.5591 12.6 18.7117 12.5368 18.8243 12.4243C18.9368 12.3117 19 12.1591 19 12V5.6C19 5.44087 18.9368 5.28826 18.8243 5.17573C18.7117 5.06321 18.5591 5 18.4 5H7.59999C7.47016 5 7.34384 5.04211 7.23998 5.12C7.13623 5.19781 7.06049 5.30715 7.02409 5.43163M7.02409 5.43163L5.16009 11.8316C5.13401 11.921 5.129 12.0157 5.14566 12.1073C5.16233 12.199 5.2001 12.2855 5.25599 12.36C5.31187 12.4345 5.38434 12.495 5.46766 12.5366C5.55097 12.5783 5.64284 12.6 5.73599 12.6H10.4C10.7067 12.6 10.9965 12.7408 11.1861 12.9819C11.3757 13.223 11.4441 13.5378 11.3718 13.8359L10.5718 17.1319L10.5708 17.1357C10.5165 17.3557 10.5126 17.5851 10.5594 17.8069C10.6062 18.0286 10.7026 18.2369 10.8412 18.4161C10.9798 18.5954 11.1571 18.7411 11.3599 18.8422C11.387 18.8557 11.4145 18.8684 11.4423 18.8802"
        fill="currentColor"
      />
    </svg>
  );
}
